import script from "./ProductGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductGuide.vue?vue&type=script&setup=true&lang=js"

import "./ProductGuide.vue?vue&type=style&index=0&id=b47df06a&scoped=true&lang=css"
import "./ProductGuide.vue?vue&type=style&index=1&id=b47df06a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b47df06a"]])

export default __exports__